const initialState = {
  lessonsData: [],
  lessonEntryData: null,
  isLoading: false,
  isLessonEditorVisible: false,
  isModalConfirmDeleteOpen: false,
  currentQuiz: null,
  questions: [],
  fillQuestions: [],
  availableQuestions: [],
  isLoadingQuestions: false,
  chapters: [],
  chaptersByGradeSubject: [],
  vanHoaExams: [],
  isLoadingVanHoaLessons: false,
  vanhoaQuizFillQuestions: [],
};

const vanhoalessonsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_VANHOA_LESSONS":
      return {
        ...state,
        lessonsData: action.payload,
      };
    case "SET_LOADING_VANHOA_LESSONS":
      return {
        ...state,
        isLoading: action.payload,
      };
    case "TOGGLE_LESSON_EDITOR_VISIBLE":
      return {
        ...state,
        isLessonEditorVisible: !state.isLessonEditorVisible,
      };
    case "TOGGLE_LESSON_UPDATE":
      return {
        ...state,
        isLessonEditorVisible: !state.isLessonEditorVisible,
        lessonEntryData: action.payload,
      };
    case "CLEAR_LESSON_ENTRY_DATA":
      return {
        ...state,
        lessonEntryData: null,
      };
    case "TOGGLE_MODAL_CONFIRM_DELETE_LESSON":
      return {
        ...state,
        isModalConfirmDeleteOpen: !state.isModalConfirmDeleteOpen,
        lessonEntryData: action.payload,
      };
    case "FETCH_QUIZ_FOR_LESSON":
      return {
        ...state,
        currentQuiz: action.payload,
      };
    case "FETCH_QUESTIONS":
      return {
        ...state,
        questions: action.payload,
        availableQuestions: action.payload,
      };
    case "FETCH_FILL_QUESTIONS":
      return {
        ...state,
        fillQuestions: action.payload,
      };
    case "SET_LOADING_QUESTIONS":
      return {
        ...state,
        isLoadingQuestions: action.payload,
      };
    case "FETCH_CHAPTERS":
      return {
        ...state,
        chapters: action.payload,
      };
    case "FETCH_CHAPTERS_BY_GRADE_SUBJECT":
      return {
        ...state,
        chaptersByGradeSubject: action.payload,
      };
    case "FETCH_VANHOA_EXAMS":
      return {
        ...state,
        vanHoaExams: action.payload,
      };
    case "FETCH_VANHOA_QUIZ_FILL_QUESTIONS":
      return {
        ...state,
        vanhoaQuizFillQuestions: action.payload,
      };
    default:
      return state;
  }
};

export default vanhoalessonsReducer;